// Collection top-bar view switches. Both states live on #ProductGridContainer,
// the one element the facets re-render keeps, so a filtered grid comes back with
// the shopper's choice intact.
(function () {
  const GRID_VIEW_STORAGE_KEY = "theme:collection-grid-view";
  const SMALL_VIEW_COLUMNS = { lg: 4, xl: 5 };

  class CollectionViewSwitches {
    constructor(section) {
      this.section = section;
      this.grid = section.querySelector("#ProductGridContainer");
      this.gridButtons = Array.from(
        section.querySelectorAll("[data-grid-view]")
      );
      this.mediaButtons = Array.from(
        section.querySelectorAll("[data-media-view]")
      );

      if (!this.grid) return;

      this.controller = new AbortController();
      this.defaultColumns = {
        lg: this.grid.style.getPropertyValue("--grid-columns-lg"),
        xl: this.grid.style.getPropertyValue("--grid-columns-xl"),
      };

      this.gridButtons.forEach((button) => {
        button.addEventListener(
          "click",
          () => this.setGridView(button.dataset.gridView),
          { signal: this.controller.signal }
        );
      });

      this.mediaButtons.forEach((button) => {
        button.addEventListener(
          "click",
          () => this.setMediaView(button.dataset.mediaView),
          { signal: this.controller.signal }
        );
      });

      if (this.gridButtons.length) {
        this.setGridView(this.readStoredGridView(), true);
      }
    }

    readStoredGridView() {
      try {
        return window.localStorage.getItem(GRID_VIEW_STORAGE_KEY) || "large";
      } catch (error) {
        return "large";
      }
    }

    storeGridView(view) {
      try {
        window.localStorage.setItem(GRID_VIEW_STORAGE_KEY, view);
      } catch (error) {
        // Private-mode storage is unavailable; the view still applies for this page.
      }
    }

    setGridView(view, silent) {
      const isSmall = view === "small";

      if (isSmall) {
        this.grid.style.setProperty("--grid-columns-lg", SMALL_VIEW_COLUMNS.lg);
        this.grid.style.setProperty("--grid-columns-xl", SMALL_VIEW_COLUMNS.xl);
      } else {
        this.grid.style.setProperty(
          "--grid-columns-lg",
          this.defaultColumns.lg
        );
        this.grid.style.setProperty(
          "--grid-columns-xl",
          this.defaultColumns.xl
        );
      }

      this.gridButtons.forEach((button) => {
        const isActive = button.dataset.gridView === (isSmall ? "small" : "large");
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
      });

      if (!silent) this.storeGridView(isSmall ? "small" : "large");
    }

    setMediaView(view) {
      const isModel = view === "model";
      this.grid.classList.toggle("is-model-view", isModel);

      this.mediaButtons.forEach((button) => {
        const isActive = button.dataset.mediaView === (isModel ? "model" : "product");
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    }

    destroy() {
      this.controller?.abort();
      this.grid?.classList.remove("is-model-view");
    }
  }

  function initSection(section) {
    if (!section || !section.classList.contains("collection-section")) return;

    if (section._collectionViewSwitches) {
      section._collectionViewSwitches.destroy();
      section._collectionViewSwitches = null;
    }

    section._collectionViewSwitches = new CollectionViewSwitches(section);
  }

  initSection(document.currentScript.parentElement);

  if (!window.__themeCollectionViewEvents) {
    window.__themeCollectionViewEvents = true;

    document.addEventListener("shopify:section:load", (event) => {
      initSection(event.target);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      const section = event.target;
      if (!section?._collectionViewSwitches) return;

      section._collectionViewSwitches.destroy();
      section._collectionViewSwitches = null;
    });
  }
})();
